import * as React from 'react';
import { Dialog, DialogTitle, IconButton, DialogContent, Theme, withStyles } from '@material-ui/core';
import FormComponent from '../FormComponent';
import CloseIcon from '@material-ui/icons/Close';
import { FormActionType } from '../../models/SubmissionModel';

export interface OwnProps {
    title: string;
    formSubmission: any;
    showDialog: boolean;
    formAlias: string;
    onClose: () => void;
    onSubmit?: (data : any) => void;
    classes?: any;
    formOptions:any;
}

const styles = (theme: Theme) => ({
    closeButton: {
        position: 'absolute' as 'absolute',
        right: 25,
        top: 10,
        color: theme.palette.grey[500],
    }
});

class EditFormDialog extends React.PureComponent<OwnProps> {
    public render() {
        const {classes} = this.props;
        return (<Dialog disableEnforceFocus={true} title={`Edit ${this.props.title}`} fullWidth={true} maxWidth={'md'}
            open={this.props.showDialog}>
            <DialogTitle id='form-edit-dialog'>{`Edit ${this.props.title}`}
                <IconButton aria-label='close' className={classes.closeButton} onClick={this.props.onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div className='container-fluid'>
                    <FormComponent formAlias={this.props.formAlias} submission={{
                        data: this.props.formSubmission
                    }}
                    action={FormActionType.UPDATE}
                    options={{ ...this.props.formOptions}}
                    onSubmit={this.props.onSubmit}/>
                </div>
            </DialogContent>
        </Dialog>);
    }
}

export default withStyles(styles) (EditFormDialog);